webpackJsonp([49916335874766],{

/***/ 11:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	module.exports = {
	  siteMetadata: {
	    title: 'Стиховник',
	    description: 'Сборник старообрядческих духовных стихов',
	    siteUrl: 'https://stihovnik.netlify.com',
	    author: 'Иван Пряхин',
	    twitter: '',
	    adsense: ''
	  },
	  pathPrefix: '/',
	  plugins: [{
	    resolve: 'gatsby-source-filesystem',
	    options: {
	      path: __dirname + '/src/pages',
	      name: 'pages'
	    }
	  }, {
	    resolve: 'gatsby-transformer-remark',
	    options: {
	      plugins: [{
	        resolve: 'gatsby-remark-images',
	        options: {
	          maxWidth: 750,
	          linkImagesToOriginal: false,
	          wrapperStyle: 'margin-bottom: 1.0725rem;'
	        }
	      }, {
	        resolve: 'gatsby-remark-responsive-iframe',
	        options: {
	          wrapperStyle: 'margin-bottom: 1.0725rem'
	        }
	      }, 'gatsby-remark-prismjs', 'gatsby-remark-copy-linked-files', 'gatsby-remark-smartypants']
	    }
	  }, {
	    resolve: 'gatsby-plugin-manifest',
	    options: {
	      name: 'Стиховник - РПСЦ',
	      short_name: 'Стиховник',
	      description: 'Стиховник - Русская Православная Старообрядческая Церковь',
	      homepage_url: 'https://stihovnik.netlify.com',
	      start_url: '/',
	      background_color: '#fff',
	      theme_color: '#016877',
	      display: 'standalone',
	      icons: [{
	        src: '/img/android-chrome-192x192.png',
	        sizes: '192x192',
	        type: 'image/png'
	      }, {
	        src: '/img/android-chrome-512x512.png',
	        sizes: '512x512',
	        type: 'image/png'
	      }]
	    }
	  }, {
	    resolve: 'gatsby-plugin-google-analytics',
	    options: {
	      trackingId: 'UA-75790669-2'
	    }
	  }, {
	    resolve: 'gatsby-plugin-netlify',
	    options: {
	      mergeSecurityHeaders: true,
	      mergeLinkHeaders: true,
	      mergeCachingHeaders: true
	    }
	  }, 'gatsby-plugin-catch-links', 'gatsby-plugin-offline', 'gatsby-plugin-react-helmet', 'gatsby-plugin-react-next', 'gatsby-plugin-sass', 'gatsby-plugin-sharp', 'gatsby-plugin-sitemap',
	  /* 'gatsby-plugin-twitter', */
	  'gatsby-transformer-sharp']
	};
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _get = __webpack_require__(24);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(35);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyConfig = __webpack_require__(11);
	
	var _gatsbyLink = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
	  }).join('&');
	}
	
	String.prototype.replaceAll = function (search, replacement) {
	  var target = this;
	  return target.replace(new RegExp(search, 'g'), replacement);
	};
	
	var PredlozhitStih = function (_React$Component) {
	  _inherits(PredlozhitStih, _React$Component);
	
	  function PredlozhitStih(props) {
	    _classCallCheck(this, PredlozhitStih);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleChange = function (e) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value.replaceAll('\\n', '&#13;&#10;'), _this$setState));
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      var form = e.target;
	      fetch('/', {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	        body: encode(_extends({
	          'form-name': form.getAttribute('name')
	        }, _this.state))
	      }).then(function () {
	        return (0, _gatsbyLink.navigateTo)(form.getAttribute('action'));
	      }).catch(function (error) {
	        return alert(error);
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  PredlozhitStih.prototype.render = function render() {
	    var _React$createElement;
	
	    var pathPrefix =  false ? '' : ("");
	    var title = 'Предложить стих';
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: title + ' | ' + (0, _get2.default)(_gatsbyConfig.siteMetadata, 'title'),
	        meta: [{ property: 'og:title', content: title }, { property: 'og:type', content: 'website' }, {
	          property: 'og:description',
	          content: (0, _get2.default)(_gatsbyConfig.siteMetadata, 'description')
	        }, {
	          property: 'og:url',
	          content: (0, _get2.default)(_gatsbyConfig.siteMetadata, 'url') + '/predlozhit-stih'
	        }, {
	          property: 'vk:image',
	          content: (0, _get2.default)(_gatsbyConfig.siteMetadata, 'url') + '/img/vkimage.jpg'
	        }, {
	          property: 'og:image',
	          content: (0, _get2.default)(_gatsbyConfig.siteMetadata, 'url') + '/img/cover.jpg'
	        }]
	      }),
	      _react2.default.createElement(
	        'section',
	        { className: 'text-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            '\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0438\u0442\u044C \u0441\u0442\u0438\u0445'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'lead text-muted' },
	            '\u0417\u0434\u0435\u0441\u044C \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0438\u0442\u044C \u0441\u0432\u043E\u0439 \u0434\u0443\u0445\u043E\u0432\u043D\u044B\u0439 \u0441\u0442\u0438\u0445, \u0438 \u043C\u044B \u0435\u0433\u043E \u0434\u043E\u0431\u0430\u0432\u0438\u043C \u0435\u0433\u043E \u043D\u0430 \u0441\u0430\u0439\u0442. ',
	            _react2.default.createElement('br', null),
	            ' \u0421\u043F\u0430\u0441\u0438 \u0425\u0440\u0438\u0441\u0442\u043E\u0441!'
	          )
	        ),
	        _react2.default.createElement(
	          'form',
	          {
	            name: 'new stih',
	            id: 'newStih',
	            method: 'post',
	            action: '/spasi-hristos',
	            'data-netlify': 'true',
	            'data-netlify-honeypot': 'no-field',
	            className: 'container',
	            onSubmit: this.handleSubmit
	          },
	          _react2.default.createElement('input', { type: 'hidden', name: 'no-field', onChange: this.handleChange }),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement('input', (_React$createElement = {
	              type: 'text',
	              name: 'name',
	              onChange: this.handleChange,
	              className: 'form-control form-control-lg',
	              placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0441\u0442\u0438\u0445\u0430'
	            }, _React$createElement['onChange'] = this.handleChange, _React$createElement))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement('textarea', {
	              className: 'form-control form-control-lg',
	              name: 'stih-text',
	              placeholder: '\u0414\u0443\u0445\u043E\u0432\u043D\u044B\u0439 \u0441\u0442\u0438\u0445',
	              rows: '10',
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement('textarea', {
	              className: 'form-control form-control-lg',
	              name: 'comment',
	              placeholder: '\u0417\u0434\u0435\u0441\u044C \u043C\u043E\u0436\u043D\u043E \u043D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439 (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0438\u0441\u0442\u043E\u0440\u0438\u044E \u0441\u0442\u0438\u0445\u0430, \u0438\u043C\u044F \u0430\u0432\u0442\u043E\u0440\u0430 \u0438 \u0442.\u0434.)',
	              rows: '3',
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-primary btn-lg' },
	            '\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C'
	          )
	        )
	      )
	    );
	  };
	
	  return PredlozhitStih;
	}(_react2.default.Component);
	
	exports.default = PredlozhitStih;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-predlozhit-stih-index-jsx-abaf47665861fda46ec5.js